import './App.css'
import { lazy, Suspense } from 'react'
import Pages from "@/pages/index.jsx"

const Toaster = lazy(() => import("@/components/ui/toaster").then((module) => ({ default: module.Toaster })))

function App() {
  return (
    <>
      <Pages />
      <Suspense fallback={null}>
        <Toaster />
      </Suspense>
    </>
  )
}

export default App 
